// Read-only directory context. Explicit team evidence is never inferred from a name.
const text = value => String(value ?? '').trim()
function gender(value) {
  const words = text(value).toLowerCase().replace(/[’']/g, '').split(/[^a-z]+/)
  const girls = words.some(word => ['girls','girl','women','womens','female','ladies'].includes(word))
  const boys = words.some(word => ['boys','boy','men','mens','male'].includes(word))
  return girls && boys ? 'conflict' : girls ? 'Girls' : boys ? 'Boys' : ''
}
export function championshipCoachSport(record) {
  const sport = text(record?.sport)
  const evidence = [record?.gender, record?.raw?.sr_gender, sport, record?.name].map(gender).filter(Boolean)
  if (evidence.includes('conflict') || new Set(evidence).size > 1) return null
  return evidence.length && !gender(sport) ? `${evidence[0]} ${sport}`.trim() : sport
}
